<div id="wellness" class="works-area pt-100 pb-70">
    <div class="container">
        <div class="section-title text-center">
            <h2 [innerHTML]="wellnessConfig.title | linebreaks"></h2>
            <p [innerHTML]="wellnessConfig.description | linebreaks"></p>
        </div>
        <div class="faq-accordion">
            <accordion [closeOthers]="false">
                <ng-container *ngFor="let item of wellnessConfig.accordion; let i = index">
                    <accordion-group [heading]="item.heading" [isOpened]="i === 0">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-6 col-sm-12">
                                    <img [src]="item.image" alt="IMG" class="mb-3" />
                                </div>
                                <div class="col-lg-6 col-sm-12 d-flex flex-column justify-content-center">
                                    <div class="faq-title">{{item.title}}</div>
                                    {{item.description}}
                                </div>
                            </div>
                        </div>
                    </accordion-group>
                </ng-container>
            </accordion>
        </div>
    </div>
</div>